import type { CreateDeviceStateRequest } from "@/generated/api/types.gen"
import { logger } from "@/platform/observability/logger"

let fingerprintPromise: Promise<string> | null = null

export const getFingerprintId = async (): Promise<string> => {
  if (!fingerprintPromise) {
    fingerprintPromise = (async () => {
      try {
        const { load } = await import("@fingerprintjs/fingerprintjs")
        const fp = await load()
        const result = await fp.get()
        return result.visitorId
      } catch (error) {
        logger.error("Error generating fingerprint", {}, error as Error)
        return crypto.randomUUID().replace(/-/g, "")
      }
    })()
  }

  return fingerprintPromise
}

// Device signals api-v2 records alongside a loan. The web has no location or hardware readings, so
// the browser fingerprint is all we send. Best-effort: null when the fingerprint can't be produced.
export const getDeviceStateRequest = async (): Promise<CreateDeviceStateRequest | null> => {
  try {
    return { state: { fingerprintDetails: { visitorId: await getFingerprintId() }, location: null } }
  } catch (error) {
    logger.error("Error building device state", {}, error as Error)
    return null
  }
}
